import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import {
  CurrentCarouselSlideSkeleton,
  CurrentCarouselSlideWrapper,
  GalleryImageCarouselContentWrapper,
  GalleryImageCarouselWrapper,
  GalleryThumbnailsWrapper,
} from './styles'

export const CarouselImageSectionSkeleton = () => (
  <GalleryImageCarouselWrapper>
    <GalleryImageCarouselContentWrapper>
      <GalleryThumbnailsWrapper>
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
        <Skeleton height='100px' width='100px' animated />
        <Spacer height={10} />
      </GalleryThumbnailsWrapper>

      <CurrentCarouselSlideWrapper>
        <CurrentCarouselSlideSkeleton animated height='auto' width='100%' />
      </CurrentCarouselSlideWrapper>
    </GalleryImageCarouselContentWrapper>

    <Spacer height={64} />
  </GalleryImageCarouselWrapper>
)
